import { locateID } from "@xbs/lib-dom";
import { isDefined } from "../../helpers";
import { menuIsEnabled } from "../../common/menu";
export function taskMenu(node, config) {
    if (config.readonly)
        return;
    const click = (event) => {
        const element = event.target;
        const isContextMenu = event.button === 2;
        if (element || isContextMenu) {
            const id = locateID(element, "data-list-id");
            const menuId = locateID(element, "data-menu-id");
            handleMenuAction({
                id,
                menuId,
                api: config.api,
                context: isContextMenu,
            });
        }
    };
    node.addEventListener("click", click);
    node.addEventListener("contextmenu", click);
    return {
        destroy() {
            node.removeEventListener("click", click);
            node.removeEventListener("contextmenu", click);
        },
    };
}
function handleMenuAction({ api, id, menuId, context }) {
    const { menuState, menu } = api.getState();
    const source = api.getSelection({ sorted: true });
    if (menuState && menuState.type === "task") {
        api.exec("close-menu", {
            ...menuState,
        });
    }
    if (source.length && (context || isDefined(menuId))) {
        const showMenu = menuIsEnabled(menu, {
            store: api.getStores().state,
            type: "task",
            source,
        });
        if (showMenu) {
            api.exec("open-menu", {
                id,
                type: "task",
                source,
            });
        }
    }
}
//# sourceMappingURL=taskMenu.js.map